import { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { member_init_without_token } from "src/DAL/ContentSetting/ContentSetting";
import ReactGA from "react-ga";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";
import {
  GUEST_HOME_PATH,
  isGuestAllowedPath,
  isGuestMember,
} from "src/utils/guestMember";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 65;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { userInfo } = useContentSetting();

  function test(words) {
    var n = words.split("=");
    return n[n.length - 1];
  }

  let mobileView = test(location.search);

  const handleGetContentData = async () => {
    const result = await member_init_without_token();
    if (result.code === 200) {
      localStorage.setItem(
        `page_content`,
        JSON.stringify(result?.content_setting?.client_content_setting),
      );
      localStorage.setItem(
        `project_info`,
        JSON.stringify(result?.content_setting?.client_general_setting),
      );
      ReactGA.initialize(
        result?.content_setting?.client_general_setting?.analytic_google_code,
        { debug: true },
      );
      ReactGA.pageview(location.pathname + location.search);
    } else {
    }
  };

  useEffect(() => {
    handleGetContentData();
  }, []);

  if (!localStorage.getItem("token")) {
    return <Navigate to="/login"> </Navigate>;
  }

  // Journey guests only get Dashboard + Journeys.
  if (isGuestMember(userInfo) && !isGuestAllowedPath(location.pathname)) {
    return <Navigate to={GUEST_HOME_PATH} replace />;
  }

  return (
    <RootStyle>
      {mobileView == "mobile" ? (
        ""
      ) : (
        <>
          <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
          <DashboardSidebar
            isOpenSidebar={open}
            onCloseSidebar={() => setOpen(false)}
          />
        </>
      )}

      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
